'use strict';

const AnnouncementPopup = require('./popups/announcement.js');
const AnnouncementStickyBottomPopup = require('./popups/announcement-sticky-bottom.js');

function initAnnouncement (ref) {
  var announcement = new AnnouncementPopup(ref);
  announcement.bindEvents();
}

function initAnnouncementStickyBottom (ref) {
  var announcement = new AnnouncementStickyBottomPopup(ref);
  announcement.bindEvents();
}

module.exports = {
  initAnnouncement: initAnnouncement,
  initAnnouncementStickyBottom: initAnnouncementStickyBottom
};



//////////////////
// WEBPACK FOOTER
// ./_js/global.js
// module id = 24
// module chunks = 3